import { Rule } from '@superbet-group/web.types';

import { RuleDto } from '@core/mappers/offer/dtos/RuleDto';

export function transformRule(dto: RuleDto): Rule {
    return {
        name: dto.name,
        modifier: dto.modifier,
        param1: dto.param1,
        param2: dto.param2,
    };
}
